import { useSpaceGroupResource } from "@circle-react/contexts/useSpaceGroupResource";
import { useNavigate } from "@tanstack/react-router";
import { useMutation } from "react-query";

import { t } from "@/i18n-js/instance";
import { spaceGroupApi } from "@/react/api/spaceGroupApi";
import { useToast } from "@/react/components/SettingsApp/CompassCompat/Toast";

export const useEditSpaceGroupMutation = ({ spaceGroup, onSuccess }) => {
  const { success, error } = useToast();
  const navigate = useNavigate();
  const { refetch } = useSpaceGroupResource(spaceGroup.id);

  const mutationFn = formData => {
    const { moderator_community_member_ids, ...spaceGroupValues } = formData;
    return spaceGroupApi.update(spaceGroup.id, {
      space_group: spaceGroupValues,
      moderator_community_member_ids,
    });
  };

  const mutation = useMutation({
    mutationFn: mutationFn,
    onSuccess: response => {
      success(t("space_groups.form.edit.saved_successfully"));
      refetch();
      onSuccess();
      void navigate({
        to: "/s/$spaceGroupSlug",
        params: { spaceGroupSlug: response.slug },
      });
    },
    onError: () => error(t("space_groups.form.create.save_error")),
  });

  return {
    ...mutation,
    spaceGroup,
  };
};
